/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './../app/routes/__root'
import { Route as SignUpRouteImport } from './../app/routes/sign-up'
import { Route as SignInRouteImport } from './../app/routes/sign-in'
import { Route as AuthTestRouteRouteImport } from './../app/routes/auth-test-route'
import { Route as AdminRouteImport } from './../app/routes/admin'
import { Route as DashboardRouteImport } from './../app/routes/_dashboard'
import { Route as DashboardIndexRouteImport } from './../app/routes/_dashboard.index'
import { Route as AuthTestingRouteImport } from './../app/routes/auth.testing'
import { Route as AuthCliRouteImport } from './../app/routes/auth.cli'
import { Route as DashboardNewOrganizationRouteImport } from './../app/routes/_dashboard.new-organization'
import { Route as DashboardMcpAuthCallbackRouteImport } from './../app/routes/_dashboard.mcp-auth-callback'
import { Route as DashboardPersonalRouteImport } from './../app/routes/_dashboard._personal'
import { Route as DashboardAccountRouteImport } from './../app/routes/_dashboard.$account'
import { Route as DashboardAccountIndexRouteImport } from './../app/routes/_dashboard.$account.index'
import { Route as DashboardInvitesIdRouteImport } from './../app/routes/_dashboard.invites.$id'
import { Route as DashboardAccountSettingsRouteImport } from './../app/routes/_dashboard.$account.settings'
import { Route as DashboardPersonalSettingsIndexRouteImport } from './../app/routes/_dashboard._personal.settings.index'
import { Route as DashboardAccountSupportIndexRouteImport } from './../app/routes/_dashboard.$account.support.index'
import { Route as DashboardAccountSettingsIndexRouteImport } from './../app/routes/_dashboard.$account.settings.index'
import { Route as DashboardAccountNexusIndexRouteImport } from './../app/routes/_dashboard.$account.nexus.index'
import { Route as DashboardAccountGraphqlIndexRouteImport } from './../app/routes/_dashboard.$account.graphql.index'
import { Route as DashboardPersonalSettingsDangerZoneRouteImport } from './../app/routes/_dashboard._personal.settings.danger-zone'
import { Route as DashboardPersonalSettingsAccessTokensRouteImport } from './../app/routes/_dashboard._personal.settings.access-tokens'
import { Route as DashboardAccountSettingsSecurityRouteImport } from './../app/routes/_dashboard.$account.settings.security'
import { Route as DashboardAccountSettingsMembersRouteImport } from './../app/routes/_dashboard.$account.settings.members'
import { Route as DashboardAccountSettingsDangerZoneRouteImport } from './../app/routes/_dashboard.$account.settings.danger-zone'
import { Route as DashboardAccountSettingsAuditLogsRouteImport } from './../app/routes/_dashboard.$account.settings.audit-logs'
import { Route as DashboardAccountSettingsAccessTokensRouteImport } from './../app/routes/_dashboard.$account.settings.access-tokens'
import { Route as DashboardAccountSettingsTeamsIndexRouteImport } from './../app/routes/_dashboard.$account.settings.teams.index'
import { Route as DashboardAccountSupportThreadThreadIdRouteImport } from './../app/routes/_dashboard.$account.support.thread.$threadId'
import { Route as DashboardAccountSettingsTeamsTeamTeamRouteImport } from './../app/routes/_dashboard.$account.settings.teams.$team._team'
import { Route as DashboardAccountGraphqlGraphBranchesBranchRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch'
import { Route as DashboardAccountGraphqlGraphBranchesBranchIndexRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.index'
import { Route as DashboardAccountSettingsTeamsTeamTeamTeamsRouteImport } from './../app/routes/_dashboard.$account.settings.teams.$team._team.teams'
import { Route as DashboardAccountSettingsTeamsTeamTeamSettingsRouteImport } from './../app/routes/_dashboard.$account.settings.teams.$team._team.settings'
import { Route as DashboardAccountSettingsTeamsTeamTeamMembersRouteImport } from './../app/routes/_dashboard.$account.settings.teams.$team._team.members'
import { Route as DashboardAccountSettingsTeamsTeamTeamGraphsRouteImport } from './../app/routes/_dashboard.$account.settings.teams.$team._team.graphs'
import { Route as DashboardAccountGraphqlGraphBranchesBranchTracesRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.traces'
import { Route as DashboardAccountGraphqlGraphBranchesBranchSubgraphsRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.subgraphs'
import { Route as DashboardAccountGraphqlGraphBranchesBranchSettingsRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.settings'
import { Route as DashboardAccountGraphqlGraphBranchesBranchSchemaRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.schema'
import { Route as DashboardAccountGraphqlGraphBranchesBranchExplorerRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.explorer'
import { Route as DashboardAccountGraphqlGraphBranchesBranchAnalyticsRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.analytics'
import { Route as DashboardAccountGraphqlGraphBranchesBranchSettingsIndexRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.settings.index'
import { Route as DashboardAccountGraphqlGraphBranchesBranchProposalsIndexRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.proposals.index'
import { Route as DashboardAccountGraphqlGraphBranchesBranchDeploymentsIndexRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.deployments.index'
import { Route as DashboardAccountGraphqlGraphBranchesBranchChecksIndexRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.checks.index'
import { Route as DashboardAccountGraphqlGraphBranchesBranchTracesIdRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.traces.$id'
import { Route as DashboardAccountGraphqlGraphBranchesBranchChecksIdRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.checks.$id'
import { Route as DashboardAccountGraphqlGraphBranchesBranchChangelogVersionRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.changelog.$version'
import { Route as DashboardAccountGraphqlGraphBranchesBranchSettingsGraphIndexRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.settings.graph.index'
import { Route as DashboardAccountGraphqlGraphBranchesBranchSettingsGraphUsageRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.settings.graph.usage'
import { Route as DashboardAccountGraphqlGraphBranchesBranchSettingsGraphOperationChecksRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.settings.graph.operation-checks'
import { Route as DashboardAccountGraphqlGraphBranchesBranchSettingsGraphDangerZoneRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.settings.graph.danger-zone'
import { Route as DashboardAccountGraphqlGraphBranchesBranchSettingsGraphCustomChecksRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.settings.graph.custom-checks'
import { Route as DashboardAccountGraphqlGraphBranchesBranchSettingsGraphBranchesRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.settings.graph.branches'
import { Route as DashboardAccountGraphqlGraphBranchesBranchSettingsBranchProposalsRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.settings.branch.proposals'
import { Route as DashboardAccountGraphqlGraphBranchesBranchSettingsBranchExplorerRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.settings.branch.explorer'
import { Route as DashboardAccountGraphqlGraphBranchesBranchSettingsBranchDangerZoneRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.settings.branch.danger-zone'
import { Route as DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.proposals.$id._proposal'
import { Route as DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.deployments.$id._deployment'
import { Route as DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalIndexRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.proposals.$id._proposal.index'
import { Route as DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentIndexRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.deployments.$id._deployment.index'
import { Route as DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalEditorRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.proposals.$id._proposal.editor'
import { Route as DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalDiffRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.proposals.$id._proposal.diff'
import { Route as DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalActivityRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.proposals.$id._proposal.activity'
import { Route as DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentSchemaRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.deployments.$id._deployment.schema'
import { Route as DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentDiffRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.deployments.$id._deployment.diff'
import { Route as DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentBuildInputsRouteImport } from './../app/routes/_dashboard.$account.graphql.$graph.branches.$branch.deployments.$id._deployment.build-inputs'

const DashboardAccountSettingsTeamsTeamRouteImport = createFileRoute(
  '/_dashboard/$account/settings/teams/$team',
)()
const DashboardAccountGraphqlGraphBranchesBranchProposalsIdRouteImport =
  createFileRoute(
    '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/$id',
  )()
const DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdRouteImport =
  createFileRoute(
    '/_dashboard/$account/graphql/$graph/branches/$branch/deployments/$id',
  )()

const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthTestRouteRoute = AuthTestRouteRouteImport.update({
  id: '/auth-test-route',
  path: '/auth-test-route',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const AuthTestingRoute = AuthTestingRouteImport.update({
  id: '/auth/testing',
  path: '/auth/testing',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCliRoute = AuthCliRouteImport.update({
  id: '/auth/cli',
  path: '/auth/cli',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardNewOrganizationRoute =
  DashboardNewOrganizationRouteImport.update({
    id: '/new-organization',
    path: '/new-organization',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardMcpAuthCallbackRoute =
  DashboardMcpAuthCallbackRouteImport.update({
    id: '/mcp-auth-callback',
    path: '/mcp-auth-callback',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardPersonalRoute = DashboardPersonalRouteImport.update({
  id: '/_personal',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAccountRoute = DashboardAccountRouteImport.update({
  id: '/$account',
  path: '/$account',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAccountIndexRoute = DashboardAccountIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardAccountRoute,
} as any)
const DashboardInvitesIdRoute = DashboardInvitesIdRouteImport.update({
  id: '/invites/$id',
  path: '/invites/$id',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAccountSettingsRoute =
  DashboardAccountSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => DashboardAccountRoute,
  } as any)
const DashboardPersonalSettingsIndexRoute =
  DashboardPersonalSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => DashboardPersonalRoute,
  } as any)
const DashboardAccountSupportIndexRoute =
  DashboardAccountSupportIndexRouteImport.update({
    id: '/support/',
    path: '/support/',
    getParentRoute: () => DashboardAccountRoute,
  } as any)
const DashboardAccountSettingsIndexRoute =
  DashboardAccountSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardAccountSettingsRoute,
  } as any)
const DashboardAccountNexusIndexRoute =
  DashboardAccountNexusIndexRouteImport.update({
    id: '/nexus/',
    path: '/nexus/',
    getParentRoute: () => DashboardAccountRoute,
  } as any)
const DashboardAccountGraphqlIndexRoute =
  DashboardAccountGraphqlIndexRouteImport.update({
    id: '/graphql/',
    path: '/graphql/',
    getParentRoute: () => DashboardAccountRoute,
  } as any)
const DashboardPersonalSettingsDangerZoneRoute =
  DashboardPersonalSettingsDangerZoneRouteImport.update({
    id: '/settings/danger-zone',
    path: '/settings/danger-zone',
    getParentRoute: () => DashboardPersonalRoute,
  } as any)
const DashboardPersonalSettingsAccessTokensRoute =
  DashboardPersonalSettingsAccessTokensRouteImport.update({
    id: '/settings/access-tokens',
    path: '/settings/access-tokens',
    getParentRoute: () => DashboardPersonalRoute,
  } as any)
const DashboardAccountSettingsSecurityRoute =
  DashboardAccountSettingsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => DashboardAccountSettingsRoute,
  } as any)
const DashboardAccountSettingsMembersRoute =
  DashboardAccountSettingsMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => DashboardAccountSettingsRoute,
  } as any)
const DashboardAccountSettingsDangerZoneRoute =
  DashboardAccountSettingsDangerZoneRouteImport.update({
    id: '/danger-zone',
    path: '/danger-zone',
    getParentRoute: () => DashboardAccountSettingsRoute,
  } as any)
const DashboardAccountSettingsAuditLogsRoute =
  DashboardAccountSettingsAuditLogsRouteImport.update({
    id: '/audit-logs',
    path: '/audit-logs',
    getParentRoute: () => DashboardAccountSettingsRoute,
  } as any)
const DashboardAccountSettingsAccessTokensRoute =
  DashboardAccountSettingsAccessTokensRouteImport.update({
    id: '/access-tokens',
    path: '/access-tokens',
    getParentRoute: () => DashboardAccountSettingsRoute,
  } as any)
const DashboardAccountSettingsTeamsTeamRoute =
  DashboardAccountSettingsTeamsTeamRouteImport.update({
    id: '/teams/$team',
    path: '/teams/$team',
    getParentRoute: () => DashboardAccountSettingsRoute,
  } as any)
const DashboardAccountSettingsTeamsIndexRoute =
  DashboardAccountSettingsTeamsIndexRouteImport.update({
    id: '/teams/',
    path: '/teams/',
    getParentRoute: () => DashboardAccountSettingsRoute,
  } as any)
const DashboardAccountSupportThreadThreadIdRoute =
  DashboardAccountSupportThreadThreadIdRouteImport.update({
    id: '/support/thread/$threadId',
    path: '/support/thread/$threadId',
    getParentRoute: () => DashboardAccountRoute,
  } as any)
const DashboardAccountSettingsTeamsTeamTeamRoute =
  DashboardAccountSettingsTeamsTeamTeamRouteImport.update({
    id: '/_team',
    getParentRoute: () => DashboardAccountSettingsTeamsTeamRoute,
  } as any)
const DashboardAccountGraphqlGraphBranchesBranchRoute =
  DashboardAccountGraphqlGraphBranchesBranchRouteImport.update({
    id: '/graphql/$graph/branches/$branch',
    path: '/graphql/$graph/branches/$branch',
    getParentRoute: () => DashboardAccountRoute,
  } as any)
const DashboardAccountGraphqlGraphBranchesBranchIndexRoute =
  DashboardAccountGraphqlGraphBranchesBranchIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardAccountGraphqlGraphBranchesBranchRoute,
  } as any)
const DashboardAccountSettingsTeamsTeamTeamTeamsRoute =
  DashboardAccountSettingsTeamsTeamTeamTeamsRouteImport.update({
    id: '/teams',
    path: '/teams',
    getParentRoute: () => DashboardAccountSettingsTeamsTeamTeamRoute,
  } as any)
const DashboardAccountSettingsTeamsTeamTeamSettingsRoute =
  DashboardAccountSettingsTeamsTeamTeamSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => DashboardAccountSettingsTeamsTeamTeamRoute,
  } as any)
const DashboardAccountSettingsTeamsTeamTeamMembersRoute =
  DashboardAccountSettingsTeamsTeamTeamMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => DashboardAccountSettingsTeamsTeamTeamRoute,
  } as any)
const DashboardAccountSettingsTeamsTeamTeamGraphsRoute =
  DashboardAccountSettingsTeamsTeamTeamGraphsRouteImport.update({
    id: '/graphs',
    path: '/graphs',
    getParentRoute: () => DashboardAccountSettingsTeamsTeamTeamRoute,
  } as any)
const DashboardAccountGraphqlGraphBranchesBranchTracesRoute =
  DashboardAccountGraphqlGraphBranchesBranchTracesRouteImport.update({
    id: '/traces',
    path: '/traces',
    getParentRoute: () => DashboardAccountGraphqlGraphBranchesBranchRoute,
  } as any)
const DashboardAccountGraphqlGraphBranchesBranchSubgraphsRoute =
  DashboardAccountGraphqlGraphBranchesBranchSubgraphsRouteImport.update({
    id: '/subgraphs',
    path: '/subgraphs',
    getParentRoute: () => DashboardAccountGraphqlGraphBranchesBranchRoute,
  } as any)
const DashboardAccountGraphqlGraphBranchesBranchSettingsRoute =
  DashboardAccountGraphqlGraphBranchesBranchSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => DashboardAccountGraphqlGraphBranchesBranchRoute,
  } as any)
const DashboardAccountGraphqlGraphBranchesBranchSchemaRoute =
  DashboardAccountGraphqlGraphBranchesBranchSchemaRouteImport.update({
    id: '/schema',
    path: '/schema',
    getParentRoute: () => DashboardAccountGraphqlGraphBranchesBranchRoute,
  } as any)
const DashboardAccountGraphqlGraphBranchesBranchExplorerRoute =
  DashboardAccountGraphqlGraphBranchesBranchExplorerRouteImport.update({
    id: '/explorer',
    path: '/explorer',
    getParentRoute: () => DashboardAccountGraphqlGraphBranchesBranchRoute,
  } as any)
const DashboardAccountGraphqlGraphBranchesBranchAnalyticsRoute =
  DashboardAccountGraphqlGraphBranchesBranchAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => DashboardAccountGraphqlGraphBranchesBranchRoute,
  } as any)
const DashboardAccountGraphqlGraphBranchesBranchProposalsIdRoute =
  DashboardAccountGraphqlGraphBranchesBranchProposalsIdRouteImport.update({
    id: '/proposals/$id',
    path: '/proposals/$id',
    getParentRoute: () => DashboardAccountGraphqlGraphBranchesBranchRoute,
  } as any)
const DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdRoute =
  DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdRouteImport.update({
    id: '/deployments/$id',
    path: '/deployments/$id',
    getParentRoute: () => DashboardAccountGraphqlGraphBranchesBranchRoute,
  } as any)
const DashboardAccountGraphqlGraphBranchesBranchSettingsIndexRoute =
  DashboardAccountGraphqlGraphBranchesBranchSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      DashboardAccountGraphqlGraphBranchesBranchSettingsRoute,
  } as any)
const DashboardAccountGraphqlGraphBranchesBranchProposalsIndexRoute =
  DashboardAccountGraphqlGraphBranchesBranchProposalsIndexRouteImport.update({
    id: '/proposals/',
    path: '/proposals/',
    getParentRoute: () => DashboardAccountGraphqlGraphBranchesBranchRoute,
  } as any)
const DashboardAccountGraphqlGraphBranchesBranchDeploymentsIndexRoute =
  DashboardAccountGraphqlGraphBranchesBranchDeploymentsIndexRouteImport.update({
    id: '/deployments/',
    path: '/deployments/',
    getParentRoute: () => DashboardAccountGraphqlGraphBranchesBranchRoute,
  } as any)
const DashboardAccountGraphqlGraphBranchesBranchChecksIndexRoute =
  DashboardAccountGraphqlGraphBranchesBranchChecksIndexRouteImport.update({
    id: '/checks/',
    path: '/checks/',
    getParentRoute: () => DashboardAccountGraphqlGraphBranchesBranchRoute,
  } as any)
const DashboardAccountGraphqlGraphBranchesBranchTracesIdRoute =
  DashboardAccountGraphqlGraphBranchesBranchTracesIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardAccountGraphqlGraphBranchesBranchTracesRoute,
  } as any)
const DashboardAccountGraphqlGraphBranchesBranchChecksIdRoute =
  DashboardAccountGraphqlGraphBranchesBranchChecksIdRouteImport.update({
    id: '/checks/$id',
    path: '/checks/$id',
    getParentRoute: () => DashboardAccountGraphqlGraphBranchesBranchRoute,
  } as any)
const DashboardAccountGraphqlGraphBranchesBranchChangelogVersionRoute =
  DashboardAccountGraphqlGraphBranchesBranchChangelogVersionRouteImport.update({
    id: '/changelog/$version',
    path: '/changelog/$version',
    getParentRoute: () => DashboardAccountGraphqlGraphBranchesBranchRoute,
  } as any)
const DashboardAccountGraphqlGraphBranchesBranchSettingsGraphIndexRoute =
  DashboardAccountGraphqlGraphBranchesBranchSettingsGraphIndexRouteImport.update(
    {
      id: '/graph/',
      path: '/graph/',
      getParentRoute: () =>
        DashboardAccountGraphqlGraphBranchesBranchSettingsRoute,
    } as any,
  )
const DashboardAccountGraphqlGraphBranchesBranchSettingsGraphUsageRoute =
  DashboardAccountGraphqlGraphBranchesBranchSettingsGraphUsageRouteImport.update(
    {
      id: '/graph/usage',
      path: '/graph/usage',
      getParentRoute: () =>
        DashboardAccountGraphqlGraphBranchesBranchSettingsRoute,
    } as any,
  )
const DashboardAccountGraphqlGraphBranchesBranchSettingsGraphOperationChecksRoute =
  DashboardAccountGraphqlGraphBranchesBranchSettingsGraphOperationChecksRouteImport.update(
    {
      id: '/graph/operation-checks',
      path: '/graph/operation-checks',
      getParentRoute: () =>
        DashboardAccountGraphqlGraphBranchesBranchSettingsRoute,
    } as any,
  )
const DashboardAccountGraphqlGraphBranchesBranchSettingsGraphDangerZoneRoute =
  DashboardAccountGraphqlGraphBranchesBranchSettingsGraphDangerZoneRouteImport.update(
    {
      id: '/graph/danger-zone',
      path: '/graph/danger-zone',
      getParentRoute: () =>
        DashboardAccountGraphqlGraphBranchesBranchSettingsRoute,
    } as any,
  )
const DashboardAccountGraphqlGraphBranchesBranchSettingsGraphCustomChecksRoute =
  DashboardAccountGraphqlGraphBranchesBranchSettingsGraphCustomChecksRouteImport.update(
    {
      id: '/graph/custom-checks',
      path: '/graph/custom-checks',
      getParentRoute: () =>
        DashboardAccountGraphqlGraphBranchesBranchSettingsRoute,
    } as any,
  )
const DashboardAccountGraphqlGraphBranchesBranchSettingsGraphBranchesRoute =
  DashboardAccountGraphqlGraphBranchesBranchSettingsGraphBranchesRouteImport.update(
    {
      id: '/graph/branches',
      path: '/graph/branches',
      getParentRoute: () =>
        DashboardAccountGraphqlGraphBranchesBranchSettingsRoute,
    } as any,
  )
const DashboardAccountGraphqlGraphBranchesBranchSettingsBranchProposalsRoute =
  DashboardAccountGraphqlGraphBranchesBranchSettingsBranchProposalsRouteImport.update(
    {
      id: '/branch/proposals',
      path: '/branch/proposals',
      getParentRoute: () =>
        DashboardAccountGraphqlGraphBranchesBranchSettingsRoute,
    } as any,
  )
const DashboardAccountGraphqlGraphBranchesBranchSettingsBranchExplorerRoute =
  DashboardAccountGraphqlGraphBranchesBranchSettingsBranchExplorerRouteImport.update(
    {
      id: '/branch/explorer',
      path: '/branch/explorer',
      getParentRoute: () =>
        DashboardAccountGraphqlGraphBranchesBranchSettingsRoute,
    } as any,
  )
const DashboardAccountGraphqlGraphBranchesBranchSettingsBranchDangerZoneRoute =
  DashboardAccountGraphqlGraphBranchesBranchSettingsBranchDangerZoneRouteImport.update(
    {
      id: '/branch/danger-zone',
      path: '/branch/danger-zone',
      getParentRoute: () =>
        DashboardAccountGraphqlGraphBranchesBranchSettingsRoute,
    } as any,
  )
const DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalRoute =
  DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalRouteImport.update(
    {
      id: '/_proposal',
      getParentRoute: () =>
        DashboardAccountGraphqlGraphBranchesBranchProposalsIdRoute,
    } as any,
  )
const DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentRoute =
  DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentRouteImport.update(
    {
      id: '/_deployment',
      getParentRoute: () =>
        DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdRoute,
    } as any,
  )
const DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalIndexRoute =
  DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalRoute,
    } as any,
  )
const DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentIndexRoute =
  DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentRoute,
    } as any,
  )
const DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalEditorRoute =
  DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalEditorRouteImport.update(
    {
      id: '/editor',
      path: '/editor',
      getParentRoute: () =>
        DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalRoute,
    } as any,
  )
const DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalDiffRoute =
  DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalDiffRouteImport.update(
    {
      id: '/diff',
      path: '/diff',
      getParentRoute: () =>
        DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalRoute,
    } as any,
  )
const DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalActivityRoute =
  DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalActivityRouteImport.update(
    {
      id: '/activity',
      path: '/activity',
      getParentRoute: () =>
        DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalRoute,
    } as any,
  )
const DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentSchemaRoute =
  DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentSchemaRouteImport.update(
    {
      id: '/schema',
      path: '/schema',
      getParentRoute: () =>
        DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentRoute,
    } as any,
  )
const DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentDiffRoute =
  DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentDiffRouteImport.update(
    {
      id: '/diff',
      path: '/diff',
      getParentRoute: () =>
        DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentRoute,
    } as any,
  )
const DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentBuildInputsRoute =
  DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentBuildInputsRouteImport.update(
    {
      id: '/build-inputs',
      path: '/build-inputs',
      getParentRoute: () =>
        DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/admin': typeof AdminRoute
  '/auth-test-route': typeof AuthTestRouteRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/$account': typeof DashboardAccountRouteWithChildren
  '/mcp-auth-callback': typeof DashboardMcpAuthCallbackRoute
  '/new-organization': typeof DashboardNewOrganizationRoute
  '/auth/cli': typeof AuthCliRoute
  '/auth/testing': typeof AuthTestingRoute
  '/': typeof DashboardIndexRoute
  '/$account/settings': typeof DashboardAccountSettingsRouteWithChildren
  '/invites/$id': typeof DashboardInvitesIdRoute
  '/$account/': typeof DashboardAccountIndexRoute
  '/$account/settings/access-tokens': typeof DashboardAccountSettingsAccessTokensRoute
  '/$account/settings/audit-logs': typeof DashboardAccountSettingsAuditLogsRoute
  '/$account/settings/danger-zone': typeof DashboardAccountSettingsDangerZoneRoute
  '/$account/settings/members': typeof DashboardAccountSettingsMembersRoute
  '/$account/settings/security': typeof DashboardAccountSettingsSecurityRoute
  '/settings/access-tokens': typeof DashboardPersonalSettingsAccessTokensRoute
  '/settings/danger-zone': typeof DashboardPersonalSettingsDangerZoneRoute
  '/$account/graphql': typeof DashboardAccountGraphqlIndexRoute
  '/$account/nexus': typeof DashboardAccountNexusIndexRoute
  '/$account/settings/': typeof DashboardAccountSettingsIndexRoute
  '/$account/support': typeof DashboardAccountSupportIndexRoute
  '/settings': typeof DashboardPersonalSettingsIndexRoute
  '/$account/support/thread/$threadId': typeof DashboardAccountSupportThreadThreadIdRoute
  '/$account/settings/teams': typeof DashboardAccountSettingsTeamsIndexRoute
  '/$account/graphql/$graph/branches/$branch': typeof DashboardAccountGraphqlGraphBranchesBranchRouteWithChildren
  '/$account/settings/teams/$team': typeof DashboardAccountSettingsTeamsTeamTeamRouteWithChildren
  '/$account/graphql/$graph/branches/$branch/analytics': typeof DashboardAccountGraphqlGraphBranchesBranchAnalyticsRoute
  '/$account/graphql/$graph/branches/$branch/explorer': typeof DashboardAccountGraphqlGraphBranchesBranchExplorerRoute
  '/$account/graphql/$graph/branches/$branch/schema': typeof DashboardAccountGraphqlGraphBranchesBranchSchemaRoute
  '/$account/graphql/$graph/branches/$branch/settings': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsRouteWithChildren
  '/$account/graphql/$graph/branches/$branch/subgraphs': typeof DashboardAccountGraphqlGraphBranchesBranchSubgraphsRoute
  '/$account/graphql/$graph/branches/$branch/traces': typeof DashboardAccountGraphqlGraphBranchesBranchTracesRouteWithChildren
  '/$account/settings/teams/$team/graphs': typeof DashboardAccountSettingsTeamsTeamTeamGraphsRoute
  '/$account/settings/teams/$team/members': typeof DashboardAccountSettingsTeamsTeamTeamMembersRoute
  '/$account/settings/teams/$team/settings': typeof DashboardAccountSettingsTeamsTeamTeamSettingsRoute
  '/$account/settings/teams/$team/teams': typeof DashboardAccountSettingsTeamsTeamTeamTeamsRoute
  '/$account/graphql/$graph/branches/$branch/': typeof DashboardAccountGraphqlGraphBranchesBranchIndexRoute
  '/$account/graphql/$graph/branches/$branch/changelog/$version': typeof DashboardAccountGraphqlGraphBranchesBranchChangelogVersionRoute
  '/$account/graphql/$graph/branches/$branch/checks/$id': typeof DashboardAccountGraphqlGraphBranchesBranchChecksIdRoute
  '/$account/graphql/$graph/branches/$branch/traces/$id': typeof DashboardAccountGraphqlGraphBranchesBranchTracesIdRoute
  '/$account/graphql/$graph/branches/$branch/checks': typeof DashboardAccountGraphqlGraphBranchesBranchChecksIndexRoute
  '/$account/graphql/$graph/branches/$branch/deployments': typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIndexRoute
  '/$account/graphql/$graph/branches/$branch/proposals': typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIndexRoute
  '/$account/graphql/$graph/branches/$branch/settings/': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsIndexRoute
  '/$account/graphql/$graph/branches/$branch/deployments/$id': typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentRouteWithChildren
  '/$account/graphql/$graph/branches/$branch/proposals/$id': typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalRouteWithChildren
  '/$account/graphql/$graph/branches/$branch/settings/branch/danger-zone': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsBranchDangerZoneRoute
  '/$account/graphql/$graph/branches/$branch/settings/branch/explorer': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsBranchExplorerRoute
  '/$account/graphql/$graph/branches/$branch/settings/branch/proposals': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsBranchProposalsRoute
  '/$account/graphql/$graph/branches/$branch/settings/graph/branches': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsGraphBranchesRoute
  '/$account/graphql/$graph/branches/$branch/settings/graph/custom-checks': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsGraphCustomChecksRoute
  '/$account/graphql/$graph/branches/$branch/settings/graph/danger-zone': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsGraphDangerZoneRoute
  '/$account/graphql/$graph/branches/$branch/settings/graph/operation-checks': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsGraphOperationChecksRoute
  '/$account/graphql/$graph/branches/$branch/settings/graph/usage': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsGraphUsageRoute
  '/$account/graphql/$graph/branches/$branch/settings/graph': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsGraphIndexRoute
  '/$account/graphql/$graph/branches/$branch/deployments/$id/build-inputs': typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentBuildInputsRoute
  '/$account/graphql/$graph/branches/$branch/deployments/$id/diff': typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentDiffRoute
  '/$account/graphql/$graph/branches/$branch/deployments/$id/schema': typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentSchemaRoute
  '/$account/graphql/$graph/branches/$branch/proposals/$id/activity': typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalActivityRoute
  '/$account/graphql/$graph/branches/$branch/proposals/$id/diff': typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalDiffRoute
  '/$account/graphql/$graph/branches/$branch/proposals/$id/editor': typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalEditorRoute
  '/$account/graphql/$graph/branches/$branch/deployments/$id/': typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentIndexRoute
  '/$account/graphql/$graph/branches/$branch/proposals/$id/': typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalIndexRoute
}
export interface FileRoutesByTo {
  '/admin': typeof AdminRoute
  '/auth-test-route': typeof AuthTestRouteRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/mcp-auth-callback': typeof DashboardMcpAuthCallbackRoute
  '/new-organization': typeof DashboardNewOrganizationRoute
  '/auth/cli': typeof AuthCliRoute
  '/auth/testing': typeof AuthTestingRoute
  '/': typeof DashboardIndexRoute
  '/invites/$id': typeof DashboardInvitesIdRoute
  '/$account': typeof DashboardAccountIndexRoute
  '/$account/settings/access-tokens': typeof DashboardAccountSettingsAccessTokensRoute
  '/$account/settings/audit-logs': typeof DashboardAccountSettingsAuditLogsRoute
  '/$account/settings/danger-zone': typeof DashboardAccountSettingsDangerZoneRoute
  '/$account/settings/members': typeof DashboardAccountSettingsMembersRoute
  '/$account/settings/security': typeof DashboardAccountSettingsSecurityRoute
  '/settings/access-tokens': typeof DashboardPersonalSettingsAccessTokensRoute
  '/settings/danger-zone': typeof DashboardPersonalSettingsDangerZoneRoute
  '/$account/graphql': typeof DashboardAccountGraphqlIndexRoute
  '/$account/nexus': typeof DashboardAccountNexusIndexRoute
  '/$account/settings': typeof DashboardAccountSettingsIndexRoute
  '/$account/support': typeof DashboardAccountSupportIndexRoute
  '/settings': typeof DashboardPersonalSettingsIndexRoute
  '/$account/support/thread/$threadId': typeof DashboardAccountSupportThreadThreadIdRoute
  '/$account/settings/teams': typeof DashboardAccountSettingsTeamsIndexRoute
  '/$account/settings/teams/$team': typeof DashboardAccountSettingsTeamsTeamTeamRouteWithChildren
  '/$account/graphql/$graph/branches/$branch/analytics': typeof DashboardAccountGraphqlGraphBranchesBranchAnalyticsRoute
  '/$account/graphql/$graph/branches/$branch/explorer': typeof DashboardAccountGraphqlGraphBranchesBranchExplorerRoute
  '/$account/graphql/$graph/branches/$branch/schema': typeof DashboardAccountGraphqlGraphBranchesBranchSchemaRoute
  '/$account/graphql/$graph/branches/$branch/subgraphs': typeof DashboardAccountGraphqlGraphBranchesBranchSubgraphsRoute
  '/$account/graphql/$graph/branches/$branch/traces': typeof DashboardAccountGraphqlGraphBranchesBranchTracesRouteWithChildren
  '/$account/settings/teams/$team/graphs': typeof DashboardAccountSettingsTeamsTeamTeamGraphsRoute
  '/$account/settings/teams/$team/members': typeof DashboardAccountSettingsTeamsTeamTeamMembersRoute
  '/$account/settings/teams/$team/settings': typeof DashboardAccountSettingsTeamsTeamTeamSettingsRoute
  '/$account/settings/teams/$team/teams': typeof DashboardAccountSettingsTeamsTeamTeamTeamsRoute
  '/$account/graphql/$graph/branches/$branch': typeof DashboardAccountGraphqlGraphBranchesBranchIndexRoute
  '/$account/graphql/$graph/branches/$branch/changelog/$version': typeof DashboardAccountGraphqlGraphBranchesBranchChangelogVersionRoute
  '/$account/graphql/$graph/branches/$branch/checks/$id': typeof DashboardAccountGraphqlGraphBranchesBranchChecksIdRoute
  '/$account/graphql/$graph/branches/$branch/traces/$id': typeof DashboardAccountGraphqlGraphBranchesBranchTracesIdRoute
  '/$account/graphql/$graph/branches/$branch/checks': typeof DashboardAccountGraphqlGraphBranchesBranchChecksIndexRoute
  '/$account/graphql/$graph/branches/$branch/deployments': typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIndexRoute
  '/$account/graphql/$graph/branches/$branch/proposals': typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIndexRoute
  '/$account/graphql/$graph/branches/$branch/settings': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsIndexRoute
  '/$account/graphql/$graph/branches/$branch/deployments/$id': typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentIndexRoute
  '/$account/graphql/$graph/branches/$branch/proposals/$id': typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalIndexRoute
  '/$account/graphql/$graph/branches/$branch/settings/branch/danger-zone': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsBranchDangerZoneRoute
  '/$account/graphql/$graph/branches/$branch/settings/branch/explorer': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsBranchExplorerRoute
  '/$account/graphql/$graph/branches/$branch/settings/branch/proposals': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsBranchProposalsRoute
  '/$account/graphql/$graph/branches/$branch/settings/graph/branches': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsGraphBranchesRoute
  '/$account/graphql/$graph/branches/$branch/settings/graph/custom-checks': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsGraphCustomChecksRoute
  '/$account/graphql/$graph/branches/$branch/settings/graph/danger-zone': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsGraphDangerZoneRoute
  '/$account/graphql/$graph/branches/$branch/settings/graph/operation-checks': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsGraphOperationChecksRoute
  '/$account/graphql/$graph/branches/$branch/settings/graph/usage': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsGraphUsageRoute
  '/$account/graphql/$graph/branches/$branch/settings/graph': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsGraphIndexRoute
  '/$account/graphql/$graph/branches/$branch/deployments/$id/build-inputs': typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentBuildInputsRoute
  '/$account/graphql/$graph/branches/$branch/deployments/$id/diff': typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentDiffRoute
  '/$account/graphql/$graph/branches/$branch/deployments/$id/schema': typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentSchemaRoute
  '/$account/graphql/$graph/branches/$branch/proposals/$id/activity': typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalActivityRoute
  '/$account/graphql/$graph/branches/$branch/proposals/$id/diff': typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalDiffRoute
  '/$account/graphql/$graph/branches/$branch/proposals/$id/editor': typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalEditorRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_dashboard': typeof DashboardRouteWithChildren
  '/admin': typeof AdminRoute
  '/auth-test-route': typeof AuthTestRouteRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/_dashboard/$account': typeof DashboardAccountRouteWithChildren
  '/_dashboard/_personal': typeof DashboardPersonalRouteWithChildren
  '/_dashboard/mcp-auth-callback': typeof DashboardMcpAuthCallbackRoute
  '/_dashboard/new-organization': typeof DashboardNewOrganizationRoute
  '/auth/cli': typeof AuthCliRoute
  '/auth/testing': typeof AuthTestingRoute
  '/_dashboard/': typeof DashboardIndexRoute
  '/_dashboard/$account/settings': typeof DashboardAccountSettingsRouteWithChildren
  '/_dashboard/invites/$id': typeof DashboardInvitesIdRoute
  '/_dashboard/$account/': typeof DashboardAccountIndexRoute
  '/_dashboard/$account/settings/access-tokens': typeof DashboardAccountSettingsAccessTokensRoute
  '/_dashboard/$account/settings/audit-logs': typeof DashboardAccountSettingsAuditLogsRoute
  '/_dashboard/$account/settings/danger-zone': typeof DashboardAccountSettingsDangerZoneRoute
  '/_dashboard/$account/settings/members': typeof DashboardAccountSettingsMembersRoute
  '/_dashboard/$account/settings/security': typeof DashboardAccountSettingsSecurityRoute
  '/_dashboard/_personal/settings/access-tokens': typeof DashboardPersonalSettingsAccessTokensRoute
  '/_dashboard/_personal/settings/danger-zone': typeof DashboardPersonalSettingsDangerZoneRoute
  '/_dashboard/$account/graphql/': typeof DashboardAccountGraphqlIndexRoute
  '/_dashboard/$account/nexus/': typeof DashboardAccountNexusIndexRoute
  '/_dashboard/$account/settings/': typeof DashboardAccountSettingsIndexRoute
  '/_dashboard/$account/support/': typeof DashboardAccountSupportIndexRoute
  '/_dashboard/_personal/settings/': typeof DashboardPersonalSettingsIndexRoute
  '/_dashboard/$account/support/thread/$threadId': typeof DashboardAccountSupportThreadThreadIdRoute
  '/_dashboard/$account/settings/teams/': typeof DashboardAccountSettingsTeamsIndexRoute
  '/_dashboard/$account/graphql/$graph/branches/$branch': typeof DashboardAccountGraphqlGraphBranchesBranchRouteWithChildren
  '/_dashboard/$account/settings/teams/$team': typeof DashboardAccountSettingsTeamsTeamRouteWithChildren
  '/_dashboard/$account/settings/teams/$team/_team': typeof DashboardAccountSettingsTeamsTeamTeamRouteWithChildren
  '/_dashboard/$account/graphql/$graph/branches/$branch/analytics': typeof DashboardAccountGraphqlGraphBranchesBranchAnalyticsRoute
  '/_dashboard/$account/graphql/$graph/branches/$branch/explorer': typeof DashboardAccountGraphqlGraphBranchesBranchExplorerRoute
  '/_dashboard/$account/graphql/$graph/branches/$branch/schema': typeof DashboardAccountGraphqlGraphBranchesBranchSchemaRoute
  '/_dashboard/$account/graphql/$graph/branches/$branch/settings': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsRouteWithChildren
  '/_dashboard/$account/graphql/$graph/branches/$branch/subgraphs': typeof DashboardAccountGraphqlGraphBranchesBranchSubgraphsRoute
  '/_dashboard/$account/graphql/$graph/branches/$branch/traces': typeof DashboardAccountGraphqlGraphBranchesBranchTracesRouteWithChildren
  '/_dashboard/$account/settings/teams/$team/_team/graphs': typeof DashboardAccountSettingsTeamsTeamTeamGraphsRoute
  '/_dashboard/$account/settings/teams/$team/_team/members': typeof DashboardAccountSettingsTeamsTeamTeamMembersRoute
  '/_dashboard/$account/settings/teams/$team/_team/settings': typeof DashboardAccountSettingsTeamsTeamTeamSettingsRoute
  '/_dashboard/$account/settings/teams/$team/_team/teams': typeof DashboardAccountSettingsTeamsTeamTeamTeamsRoute
  '/_dashboard/$account/graphql/$graph/branches/$branch/': typeof DashboardAccountGraphqlGraphBranchesBranchIndexRoute
  '/_dashboard/$account/graphql/$graph/branches/$branch/changelog/$version': typeof DashboardAccountGraphqlGraphBranchesBranchChangelogVersionRoute
  '/_dashboard/$account/graphql/$graph/branches/$branch/checks/$id': typeof DashboardAccountGraphqlGraphBranchesBranchChecksIdRoute
  '/_dashboard/$account/graphql/$graph/branches/$branch/traces/$id': typeof DashboardAccountGraphqlGraphBranchesBranchTracesIdRoute
  '/_dashboard/$account/graphql/$graph/branches/$branch/checks/': typeof DashboardAccountGraphqlGraphBranchesBranchChecksIndexRoute
  '/_dashboard/$account/graphql/$graph/branches/$branch/deployments/': typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIndexRoute
  '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/': typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIndexRoute
  '/_dashboard/$account/graphql/$graph/branches/$branch/settings/': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsIndexRoute
  '/_dashboard/$account/graphql/$graph/branches/$branch/deployments/$id': typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdRouteWithChildren
  '/_dashboard/$account/graphql/$graph/branches/$branch/deployments/$id/_deployment': typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentRouteWithChildren
  '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/$id': typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdRouteWithChildren
  '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/$id/_proposal': typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalRouteWithChildren
  '/_dashboard/$account/graphql/$graph/branches/$branch/settings/branch/danger-zone': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsBranchDangerZoneRoute
  '/_dashboard/$account/graphql/$graph/branches/$branch/settings/branch/explorer': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsBranchExplorerRoute
  '/_dashboard/$account/graphql/$graph/branches/$branch/settings/branch/proposals': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsBranchProposalsRoute
  '/_dashboard/$account/graphql/$graph/branches/$branch/settings/graph/branches': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsGraphBranchesRoute
  '/_dashboard/$account/graphql/$graph/branches/$branch/settings/graph/custom-checks': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsGraphCustomChecksRoute
  '/_dashboard/$account/graphql/$graph/branches/$branch/settings/graph/danger-zone': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsGraphDangerZoneRoute
  '/_dashboard/$account/graphql/$graph/branches/$branch/settings/graph/operation-checks': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsGraphOperationChecksRoute
  '/_dashboard/$account/graphql/$graph/branches/$branch/settings/graph/usage': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsGraphUsageRoute
  '/_dashboard/$account/graphql/$graph/branches/$branch/settings/graph/': typeof DashboardAccountGraphqlGraphBranchesBranchSettingsGraphIndexRoute
  '/_dashboard/$account/graphql/$graph/branches/$branch/deployments/$id/_deployment/build-inputs': typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentBuildInputsRoute
  '/_dashboard/$account/graphql/$graph/branches/$branch/deployments/$id/_deployment/diff': typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentDiffRoute
  '/_dashboard/$account/graphql/$graph/branches/$branch/deployments/$id/_deployment/schema': typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentSchemaRoute
  '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/$id/_proposal/activity': typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalActivityRoute
  '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/$id/_proposal/diff': typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalDiffRoute
  '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/$id/_proposal/editor': typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalEditorRoute
  '/_dashboard/$account/graphql/$graph/branches/$branch/deployments/$id/_deployment/': typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentIndexRoute
  '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/$id/_proposal/': typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/admin'
    | '/auth-test-route'
    | '/sign-in'
    | '/sign-up'
    | '/$account'
    | '/mcp-auth-callback'
    | '/new-organization'
    | '/auth/cli'
    | '/auth/testing'
    | '/'
    | '/$account/settings'
    | '/invites/$id'
    | '/$account/'
    | '/$account/settings/access-tokens'
    | '/$account/settings/audit-logs'
    | '/$account/settings/danger-zone'
    | '/$account/settings/members'
    | '/$account/settings/security'
    | '/settings/access-tokens'
    | '/settings/danger-zone'
    | '/$account/graphql'
    | '/$account/nexus'
    | '/$account/settings/'
    | '/$account/support'
    | '/settings'
    | '/$account/support/thread/$threadId'
    | '/$account/settings/teams'
    | '/$account/graphql/$graph/branches/$branch'
    | '/$account/settings/teams/$team'
    | '/$account/graphql/$graph/branches/$branch/analytics'
    | '/$account/graphql/$graph/branches/$branch/explorer'
    | '/$account/graphql/$graph/branches/$branch/schema'
    | '/$account/graphql/$graph/branches/$branch/settings'
    | '/$account/graphql/$graph/branches/$branch/subgraphs'
    | '/$account/graphql/$graph/branches/$branch/traces'
    | '/$account/settings/teams/$team/graphs'
    | '/$account/settings/teams/$team/members'
    | '/$account/settings/teams/$team/settings'
    | '/$account/settings/teams/$team/teams'
    | '/$account/graphql/$graph/branches/$branch/'
    | '/$account/graphql/$graph/branches/$branch/changelog/$version'
    | '/$account/graphql/$graph/branches/$branch/checks/$id'
    | '/$account/graphql/$graph/branches/$branch/traces/$id'
    | '/$account/graphql/$graph/branches/$branch/checks'
    | '/$account/graphql/$graph/branches/$branch/deployments'
    | '/$account/graphql/$graph/branches/$branch/proposals'
    | '/$account/graphql/$graph/branches/$branch/settings/'
    | '/$account/graphql/$graph/branches/$branch/deployments/$id'
    | '/$account/graphql/$graph/branches/$branch/proposals/$id'
    | '/$account/graphql/$graph/branches/$branch/settings/branch/danger-zone'
    | '/$account/graphql/$graph/branches/$branch/settings/branch/explorer'
    | '/$account/graphql/$graph/branches/$branch/settings/branch/proposals'
    | '/$account/graphql/$graph/branches/$branch/settings/graph/branches'
    | '/$account/graphql/$graph/branches/$branch/settings/graph/custom-checks'
    | '/$account/graphql/$graph/branches/$branch/settings/graph/danger-zone'
    | '/$account/graphql/$graph/branches/$branch/settings/graph/operation-checks'
    | '/$account/graphql/$graph/branches/$branch/settings/graph/usage'
    | '/$account/graphql/$graph/branches/$branch/settings/graph'
    | '/$account/graphql/$graph/branches/$branch/deployments/$id/build-inputs'
    | '/$account/graphql/$graph/branches/$branch/deployments/$id/diff'
    | '/$account/graphql/$graph/branches/$branch/deployments/$id/schema'
    | '/$account/graphql/$graph/branches/$branch/proposals/$id/activity'
    | '/$account/graphql/$graph/branches/$branch/proposals/$id/diff'
    | '/$account/graphql/$graph/branches/$branch/proposals/$id/editor'
    | '/$account/graphql/$graph/branches/$branch/deployments/$id/'
    | '/$account/graphql/$graph/branches/$branch/proposals/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/admin'
    | '/auth-test-route'
    | '/sign-in'
    | '/sign-up'
    | '/mcp-auth-callback'
    | '/new-organization'
    | '/auth/cli'
    | '/auth/testing'
    | '/'
    | '/invites/$id'
    | '/$account'
    | '/$account/settings/access-tokens'
    | '/$account/settings/audit-logs'
    | '/$account/settings/danger-zone'
    | '/$account/settings/members'
    | '/$account/settings/security'
    | '/settings/access-tokens'
    | '/settings/danger-zone'
    | '/$account/graphql'
    | '/$account/nexus'
    | '/$account/settings'
    | '/$account/support'
    | '/settings'
    | '/$account/support/thread/$threadId'
    | '/$account/settings/teams'
    | '/$account/settings/teams/$team'
    | '/$account/graphql/$graph/branches/$branch/analytics'
    | '/$account/graphql/$graph/branches/$branch/explorer'
    | '/$account/graphql/$graph/branches/$branch/schema'
    | '/$account/graphql/$graph/branches/$branch/subgraphs'
    | '/$account/graphql/$graph/branches/$branch/traces'
    | '/$account/settings/teams/$team/graphs'
    | '/$account/settings/teams/$team/members'
    | '/$account/settings/teams/$team/settings'
    | '/$account/settings/teams/$team/teams'
    | '/$account/graphql/$graph/branches/$branch'
    | '/$account/graphql/$graph/branches/$branch/changelog/$version'
    | '/$account/graphql/$graph/branches/$branch/checks/$id'
    | '/$account/graphql/$graph/branches/$branch/traces/$id'
    | '/$account/graphql/$graph/branches/$branch/checks'
    | '/$account/graphql/$graph/branches/$branch/deployments'
    | '/$account/graphql/$graph/branches/$branch/proposals'
    | '/$account/graphql/$graph/branches/$branch/settings'
    | '/$account/graphql/$graph/branches/$branch/deployments/$id'
    | '/$account/graphql/$graph/branches/$branch/proposals/$id'
    | '/$account/graphql/$graph/branches/$branch/settings/branch/danger-zone'
    | '/$account/graphql/$graph/branches/$branch/settings/branch/explorer'
    | '/$account/graphql/$graph/branches/$branch/settings/branch/proposals'
    | '/$account/graphql/$graph/branches/$branch/settings/graph/branches'
    | '/$account/graphql/$graph/branches/$branch/settings/graph/custom-checks'
    | '/$account/graphql/$graph/branches/$branch/settings/graph/danger-zone'
    | '/$account/graphql/$graph/branches/$branch/settings/graph/operation-checks'
    | '/$account/graphql/$graph/branches/$branch/settings/graph/usage'
    | '/$account/graphql/$graph/branches/$branch/settings/graph'
    | '/$account/graphql/$graph/branches/$branch/deployments/$id/build-inputs'
    | '/$account/graphql/$graph/branches/$branch/deployments/$id/diff'
    | '/$account/graphql/$graph/branches/$branch/deployments/$id/schema'
    | '/$account/graphql/$graph/branches/$branch/proposals/$id/activity'
    | '/$account/graphql/$graph/branches/$branch/proposals/$id/diff'
    | '/$account/graphql/$graph/branches/$branch/proposals/$id/editor'
  id:
    | '__root__'
    | '/_dashboard'
    | '/admin'
    | '/auth-test-route'
    | '/sign-in'
    | '/sign-up'
    | '/_dashboard/$account'
    | '/_dashboard/_personal'
    | '/_dashboard/mcp-auth-callback'
    | '/_dashboard/new-organization'
    | '/auth/cli'
    | '/auth/testing'
    | '/_dashboard/'
    | '/_dashboard/$account/settings'
    | '/_dashboard/invites/$id'
    | '/_dashboard/$account/'
    | '/_dashboard/$account/settings/access-tokens'
    | '/_dashboard/$account/settings/audit-logs'
    | '/_dashboard/$account/settings/danger-zone'
    | '/_dashboard/$account/settings/members'
    | '/_dashboard/$account/settings/security'
    | '/_dashboard/_personal/settings/access-tokens'
    | '/_dashboard/_personal/settings/danger-zone'
    | '/_dashboard/$account/graphql/'
    | '/_dashboard/$account/nexus/'
    | '/_dashboard/$account/settings/'
    | '/_dashboard/$account/support/'
    | '/_dashboard/_personal/settings/'
    | '/_dashboard/$account/support/thread/$threadId'
    | '/_dashboard/$account/settings/teams/'
    | '/_dashboard/$account/graphql/$graph/branches/$branch'
    | '/_dashboard/$account/settings/teams/$team'
    | '/_dashboard/$account/settings/teams/$team/_team'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/analytics'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/explorer'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/schema'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/settings'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/subgraphs'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/traces'
    | '/_dashboard/$account/settings/teams/$team/_team/graphs'
    | '/_dashboard/$account/settings/teams/$team/_team/members'
    | '/_dashboard/$account/settings/teams/$team/_team/settings'
    | '/_dashboard/$account/settings/teams/$team/_team/teams'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/changelog/$version'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/checks/$id'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/traces/$id'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/checks/'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/deployments/'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/settings/'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/deployments/$id'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/deployments/$id/_deployment'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/$id'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/$id/_proposal'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/settings/branch/danger-zone'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/settings/branch/explorer'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/settings/branch/proposals'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/settings/graph/branches'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/settings/graph/custom-checks'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/settings/graph/danger-zone'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/settings/graph/operation-checks'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/settings/graph/usage'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/settings/graph/'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/deployments/$id/_deployment/build-inputs'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/deployments/$id/_deployment/diff'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/deployments/$id/_deployment/schema'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/$id/_proposal/activity'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/$id/_proposal/diff'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/$id/_proposal/editor'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/deployments/$id/_deployment/'
    | '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/$id/_proposal/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  DashboardRoute: typeof DashboardRouteWithChildren
  AdminRoute: typeof AdminRoute
  AuthTestRouteRoute: typeof AuthTestRouteRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  AuthCliRoute: typeof AuthCliRoute
  AuthTestingRoute: typeof AuthTestingRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth-test-route': {
      id: '/auth-test-route'
      path: '/auth-test-route'
      fullPath: '/auth-test-route'
      preLoaderRoute: typeof AuthTestRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/': {
      id: '/_dashboard/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/auth/testing': {
      id: '/auth/testing'
      path: '/auth/testing'
      fullPath: '/auth/testing'
      preLoaderRoute: typeof AuthTestingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/cli': {
      id: '/auth/cli'
      path: '/auth/cli'
      fullPath: '/auth/cli'
      preLoaderRoute: typeof AuthCliRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/new-organization': {
      id: '/_dashboard/new-organization'
      path: '/new-organization'
      fullPath: '/new-organization'
      preLoaderRoute: typeof DashboardNewOrganizationRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/mcp-auth-callback': {
      id: '/_dashboard/mcp-auth-callback'
      path: '/mcp-auth-callback'
      fullPath: '/mcp-auth-callback'
      preLoaderRoute: typeof DashboardMcpAuthCallbackRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/_personal': {
      id: '/_dashboard/_personal'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof DashboardPersonalRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/$account': {
      id: '/_dashboard/$account'
      path: '/$account'
      fullPath: '/$account'
      preLoaderRoute: typeof DashboardAccountRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/$account/': {
      id: '/_dashboard/$account/'
      path: '/'
      fullPath: '/$account/'
      preLoaderRoute: typeof DashboardAccountIndexRouteImport
      parentRoute: typeof DashboardAccountRoute
    }
    '/_dashboard/invites/$id': {
      id: '/_dashboard/invites/$id'
      path: '/invites/$id'
      fullPath: '/invites/$id'
      preLoaderRoute: typeof DashboardInvitesIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/$account/settings': {
      id: '/_dashboard/$account/settings'
      path: '/settings'
      fullPath: '/$account/settings'
      preLoaderRoute: typeof DashboardAccountSettingsRouteImport
      parentRoute: typeof DashboardAccountRoute
    }
    '/_dashboard/_personal/settings/': {
      id: '/_dashboard/_personal/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof DashboardPersonalSettingsIndexRouteImport
      parentRoute: typeof DashboardPersonalRoute
    }
    '/_dashboard/$account/support/': {
      id: '/_dashboard/$account/support/'
      path: '/support'
      fullPath: '/$account/support'
      preLoaderRoute: typeof DashboardAccountSupportIndexRouteImport
      parentRoute: typeof DashboardAccountRoute
    }
    '/_dashboard/$account/settings/': {
      id: '/_dashboard/$account/settings/'
      path: '/'
      fullPath: '/$account/settings/'
      preLoaderRoute: typeof DashboardAccountSettingsIndexRouteImport
      parentRoute: typeof DashboardAccountSettingsRoute
    }
    '/_dashboard/$account/nexus/': {
      id: '/_dashboard/$account/nexus/'
      path: '/nexus'
      fullPath: '/$account/nexus'
      preLoaderRoute: typeof DashboardAccountNexusIndexRouteImport
      parentRoute: typeof DashboardAccountRoute
    }
    '/_dashboard/$account/graphql/': {
      id: '/_dashboard/$account/graphql/'
      path: '/graphql'
      fullPath: '/$account/graphql'
      preLoaderRoute: typeof DashboardAccountGraphqlIndexRouteImport
      parentRoute: typeof DashboardAccountRoute
    }
    '/_dashboard/_personal/settings/danger-zone': {
      id: '/_dashboard/_personal/settings/danger-zone'
      path: '/settings/danger-zone'
      fullPath: '/settings/danger-zone'
      preLoaderRoute: typeof DashboardPersonalSettingsDangerZoneRouteImport
      parentRoute: typeof DashboardPersonalRoute
    }
    '/_dashboard/_personal/settings/access-tokens': {
      id: '/_dashboard/_personal/settings/access-tokens'
      path: '/settings/access-tokens'
      fullPath: '/settings/access-tokens'
      preLoaderRoute: typeof DashboardPersonalSettingsAccessTokensRouteImport
      parentRoute: typeof DashboardPersonalRoute
    }
    '/_dashboard/$account/settings/security': {
      id: '/_dashboard/$account/settings/security'
      path: '/security'
      fullPath: '/$account/settings/security'
      preLoaderRoute: typeof DashboardAccountSettingsSecurityRouteImport
      parentRoute: typeof DashboardAccountSettingsRoute
    }
    '/_dashboard/$account/settings/members': {
      id: '/_dashboard/$account/settings/members'
      path: '/members'
      fullPath: '/$account/settings/members'
      preLoaderRoute: typeof DashboardAccountSettingsMembersRouteImport
      parentRoute: typeof DashboardAccountSettingsRoute
    }
    '/_dashboard/$account/settings/danger-zone': {
      id: '/_dashboard/$account/settings/danger-zone'
      path: '/danger-zone'
      fullPath: '/$account/settings/danger-zone'
      preLoaderRoute: typeof DashboardAccountSettingsDangerZoneRouteImport
      parentRoute: typeof DashboardAccountSettingsRoute
    }
    '/_dashboard/$account/settings/audit-logs': {
      id: '/_dashboard/$account/settings/audit-logs'
      path: '/audit-logs'
      fullPath: '/$account/settings/audit-logs'
      preLoaderRoute: typeof DashboardAccountSettingsAuditLogsRouteImport
      parentRoute: typeof DashboardAccountSettingsRoute
    }
    '/_dashboard/$account/settings/access-tokens': {
      id: '/_dashboard/$account/settings/access-tokens'
      path: '/access-tokens'
      fullPath: '/$account/settings/access-tokens'
      preLoaderRoute: typeof DashboardAccountSettingsAccessTokensRouteImport
      parentRoute: typeof DashboardAccountSettingsRoute
    }
    '/_dashboard/$account/settings/teams/$team': {
      id: '/_dashboard/$account/settings/teams/$team'
      path: '/teams/$team'
      fullPath: '/$account/settings/teams/$team'
      preLoaderRoute: typeof DashboardAccountSettingsTeamsTeamRouteImport
      parentRoute: typeof DashboardAccountSettingsRoute
    }
    '/_dashboard/$account/settings/teams/': {
      id: '/_dashboard/$account/settings/teams/'
      path: '/teams'
      fullPath: '/$account/settings/teams'
      preLoaderRoute: typeof DashboardAccountSettingsTeamsIndexRouteImport
      parentRoute: typeof DashboardAccountSettingsRoute
    }
    '/_dashboard/$account/support/thread/$threadId': {
      id: '/_dashboard/$account/support/thread/$threadId'
      path: '/support/thread/$threadId'
      fullPath: '/$account/support/thread/$threadId'
      preLoaderRoute: typeof DashboardAccountSupportThreadThreadIdRouteImport
      parentRoute: typeof DashboardAccountRoute
    }
    '/_dashboard/$account/settings/teams/$team/_team': {
      id: '/_dashboard/$account/settings/teams/$team/_team'
      path: '/teams/$team'
      fullPath: '/$account/settings/teams/$team'
      preLoaderRoute: typeof DashboardAccountSettingsTeamsTeamTeamRouteImport
      parentRoute: typeof DashboardAccountSettingsTeamsTeamRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch'
      path: '/graphql/$graph/branches/$branch'
      fullPath: '/$account/graphql/$graph/branches/$branch'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchRouteImport
      parentRoute: typeof DashboardAccountRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/'
      path: '/'
      fullPath: '/$account/graphql/$graph/branches/$branch/'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchIndexRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchRoute
    }
    '/_dashboard/$account/settings/teams/$team/_team/teams': {
      id: '/_dashboard/$account/settings/teams/$team/_team/teams'
      path: '/teams'
      fullPath: '/$account/settings/teams/$team/teams'
      preLoaderRoute: typeof DashboardAccountSettingsTeamsTeamTeamTeamsRouteImport
      parentRoute: typeof DashboardAccountSettingsTeamsTeamTeamRoute
    }
    '/_dashboard/$account/settings/teams/$team/_team/settings': {
      id: '/_dashboard/$account/settings/teams/$team/_team/settings'
      path: '/settings'
      fullPath: '/$account/settings/teams/$team/settings'
      preLoaderRoute: typeof DashboardAccountSettingsTeamsTeamTeamSettingsRouteImport
      parentRoute: typeof DashboardAccountSettingsTeamsTeamTeamRoute
    }
    '/_dashboard/$account/settings/teams/$team/_team/members': {
      id: '/_dashboard/$account/settings/teams/$team/_team/members'
      path: '/members'
      fullPath: '/$account/settings/teams/$team/members'
      preLoaderRoute: typeof DashboardAccountSettingsTeamsTeamTeamMembersRouteImport
      parentRoute: typeof DashboardAccountSettingsTeamsTeamTeamRoute
    }
    '/_dashboard/$account/settings/teams/$team/_team/graphs': {
      id: '/_dashboard/$account/settings/teams/$team/_team/graphs'
      path: '/graphs'
      fullPath: '/$account/settings/teams/$team/graphs'
      preLoaderRoute: typeof DashboardAccountSettingsTeamsTeamTeamGraphsRouteImport
      parentRoute: typeof DashboardAccountSettingsTeamsTeamTeamRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/traces': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/traces'
      path: '/traces'
      fullPath: '/$account/graphql/$graph/branches/$branch/traces'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchTracesRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/subgraphs': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/subgraphs'
      path: '/subgraphs'
      fullPath: '/$account/graphql/$graph/branches/$branch/subgraphs'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSubgraphsRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/settings': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/settings'
      path: '/settings'
      fullPath: '/$account/graphql/$graph/branches/$branch/settings'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/schema': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/schema'
      path: '/schema'
      fullPath: '/$account/graphql/$graph/branches/$branch/schema'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSchemaRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/explorer': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/explorer'
      path: '/explorer'
      fullPath: '/$account/graphql/$graph/branches/$branch/explorer'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchExplorerRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/analytics': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/analytics'
      path: '/analytics'
      fullPath: '/$account/graphql/$graph/branches/$branch/analytics'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchAnalyticsRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/$id': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/$id'
      path: '/proposals/$id'
      fullPath: '/$account/graphql/$graph/branches/$branch/proposals/$id'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/deployments/$id': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/deployments/$id'
      path: '/deployments/$id'
      fullPath: '/$account/graphql/$graph/branches/$branch/deployments/$id'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/settings/': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/settings/'
      path: '/'
      fullPath: '/$account/graphql/$graph/branches/$branch/settings/'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsIndexRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/'
      path: '/proposals'
      fullPath: '/$account/graphql/$graph/branches/$branch/proposals'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIndexRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/deployments/': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/deployments/'
      path: '/deployments'
      fullPath: '/$account/graphql/$graph/branches/$branch/deployments'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIndexRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/checks/': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/checks/'
      path: '/checks'
      fullPath: '/$account/graphql/$graph/branches/$branch/checks'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchChecksIndexRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/traces/$id': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/traces/$id'
      path: '/$id'
      fullPath: '/$account/graphql/$graph/branches/$branch/traces/$id'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchTracesIdRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchTracesRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/checks/$id': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/checks/$id'
      path: '/checks/$id'
      fullPath: '/$account/graphql/$graph/branches/$branch/checks/$id'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchChecksIdRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/changelog/$version': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/changelog/$version'
      path: '/changelog/$version'
      fullPath: '/$account/graphql/$graph/branches/$branch/changelog/$version'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchChangelogVersionRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/settings/graph/': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/settings/graph/'
      path: '/graph'
      fullPath: '/$account/graphql/$graph/branches/$branch/settings/graph'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsGraphIndexRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/settings/graph/usage': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/settings/graph/usage'
      path: '/graph/usage'
      fullPath: '/$account/graphql/$graph/branches/$branch/settings/graph/usage'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsGraphUsageRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/settings/graph/operation-checks': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/settings/graph/operation-checks'
      path: '/graph/operation-checks'
      fullPath: '/$account/graphql/$graph/branches/$branch/settings/graph/operation-checks'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsGraphOperationChecksRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/settings/graph/danger-zone': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/settings/graph/danger-zone'
      path: '/graph/danger-zone'
      fullPath: '/$account/graphql/$graph/branches/$branch/settings/graph/danger-zone'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsGraphDangerZoneRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/settings/graph/custom-checks': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/settings/graph/custom-checks'
      path: '/graph/custom-checks'
      fullPath: '/$account/graphql/$graph/branches/$branch/settings/graph/custom-checks'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsGraphCustomChecksRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/settings/graph/branches': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/settings/graph/branches'
      path: '/graph/branches'
      fullPath: '/$account/graphql/$graph/branches/$branch/settings/graph/branches'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsGraphBranchesRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/settings/branch/proposals': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/settings/branch/proposals'
      path: '/branch/proposals'
      fullPath: '/$account/graphql/$graph/branches/$branch/settings/branch/proposals'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsBranchProposalsRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/settings/branch/explorer': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/settings/branch/explorer'
      path: '/branch/explorer'
      fullPath: '/$account/graphql/$graph/branches/$branch/settings/branch/explorer'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsBranchExplorerRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/settings/branch/danger-zone': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/settings/branch/danger-zone'
      path: '/branch/danger-zone'
      fullPath: '/$account/graphql/$graph/branches/$branch/settings/branch/danger-zone'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsBranchDangerZoneRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/$id/_proposal': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/$id/_proposal'
      path: '/proposals/$id'
      fullPath: '/$account/graphql/$graph/branches/$branch/proposals/$id'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/deployments/$id/_deployment': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/deployments/$id/_deployment'
      path: '/deployments/$id'
      fullPath: '/$account/graphql/$graph/branches/$branch/deployments/$id'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/$id/_proposal/': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/$id/_proposal/'
      path: '/'
      fullPath: '/$account/graphql/$graph/branches/$branch/proposals/$id/'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalIndexRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/deployments/$id/_deployment/': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/deployments/$id/_deployment/'
      path: '/'
      fullPath: '/$account/graphql/$graph/branches/$branch/deployments/$id/'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentIndexRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/$id/_proposal/editor': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/$id/_proposal/editor'
      path: '/editor'
      fullPath: '/$account/graphql/$graph/branches/$branch/proposals/$id/editor'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalEditorRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/$id/_proposal/diff': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/$id/_proposal/diff'
      path: '/diff'
      fullPath: '/$account/graphql/$graph/branches/$branch/proposals/$id/diff'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalDiffRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/$id/_proposal/activity': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/$id/_proposal/activity'
      path: '/activity'
      fullPath: '/$account/graphql/$graph/branches/$branch/proposals/$id/activity'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalActivityRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/deployments/$id/_deployment/schema': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/deployments/$id/_deployment/schema'
      path: '/schema'
      fullPath: '/$account/graphql/$graph/branches/$branch/deployments/$id/schema'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentSchemaRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/deployments/$id/_deployment/diff': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/deployments/$id/_deployment/diff'
      path: '/diff'
      fullPath: '/$account/graphql/$graph/branches/$branch/deployments/$id/diff'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentDiffRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentRoute
    }
    '/_dashboard/$account/graphql/$graph/branches/$branch/deployments/$id/_deployment/build-inputs': {
      id: '/_dashboard/$account/graphql/$graph/branches/$branch/deployments/$id/_deployment/build-inputs'
      path: '/build-inputs'
      fullPath: '/$account/graphql/$graph/branches/$branch/deployments/$id/build-inputs'
      preLoaderRoute: typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentBuildInputsRouteImport
      parentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentRoute
    }
  }
}

interface DashboardAccountSettingsTeamsTeamTeamRouteChildren {
  DashboardAccountSettingsTeamsTeamTeamGraphsRoute: typeof DashboardAccountSettingsTeamsTeamTeamGraphsRoute
  DashboardAccountSettingsTeamsTeamTeamMembersRoute: typeof DashboardAccountSettingsTeamsTeamTeamMembersRoute
  DashboardAccountSettingsTeamsTeamTeamSettingsRoute: typeof DashboardAccountSettingsTeamsTeamTeamSettingsRoute
  DashboardAccountSettingsTeamsTeamTeamTeamsRoute: typeof DashboardAccountSettingsTeamsTeamTeamTeamsRoute
}

const DashboardAccountSettingsTeamsTeamTeamRouteChildren: DashboardAccountSettingsTeamsTeamTeamRouteChildren =
  {
    DashboardAccountSettingsTeamsTeamTeamGraphsRoute:
      DashboardAccountSettingsTeamsTeamTeamGraphsRoute,
    DashboardAccountSettingsTeamsTeamTeamMembersRoute:
      DashboardAccountSettingsTeamsTeamTeamMembersRoute,
    DashboardAccountSettingsTeamsTeamTeamSettingsRoute:
      DashboardAccountSettingsTeamsTeamTeamSettingsRoute,
    DashboardAccountSettingsTeamsTeamTeamTeamsRoute:
      DashboardAccountSettingsTeamsTeamTeamTeamsRoute,
  }

const DashboardAccountSettingsTeamsTeamTeamRouteWithChildren =
  DashboardAccountSettingsTeamsTeamTeamRoute._addFileChildren(
    DashboardAccountSettingsTeamsTeamTeamRouteChildren,
  )

interface DashboardAccountSettingsTeamsTeamRouteChildren {
  DashboardAccountSettingsTeamsTeamTeamRoute: typeof DashboardAccountSettingsTeamsTeamTeamRouteWithChildren
}

const DashboardAccountSettingsTeamsTeamRouteChildren: DashboardAccountSettingsTeamsTeamRouteChildren =
  {
    DashboardAccountSettingsTeamsTeamTeamRoute:
      DashboardAccountSettingsTeamsTeamTeamRouteWithChildren,
  }

const DashboardAccountSettingsTeamsTeamRouteWithChildren =
  DashboardAccountSettingsTeamsTeamRoute._addFileChildren(
    DashboardAccountSettingsTeamsTeamRouteChildren,
  )

interface DashboardAccountSettingsRouteChildren {
  DashboardAccountSettingsAccessTokensRoute: typeof DashboardAccountSettingsAccessTokensRoute
  DashboardAccountSettingsAuditLogsRoute: typeof DashboardAccountSettingsAuditLogsRoute
  DashboardAccountSettingsDangerZoneRoute: typeof DashboardAccountSettingsDangerZoneRoute
  DashboardAccountSettingsMembersRoute: typeof DashboardAccountSettingsMembersRoute
  DashboardAccountSettingsSecurityRoute: typeof DashboardAccountSettingsSecurityRoute
  DashboardAccountSettingsIndexRoute: typeof DashboardAccountSettingsIndexRoute
  DashboardAccountSettingsTeamsIndexRoute: typeof DashboardAccountSettingsTeamsIndexRoute
  DashboardAccountSettingsTeamsTeamRoute: typeof DashboardAccountSettingsTeamsTeamRouteWithChildren
}

const DashboardAccountSettingsRouteChildren: DashboardAccountSettingsRouteChildren =
  {
    DashboardAccountSettingsAccessTokensRoute:
      DashboardAccountSettingsAccessTokensRoute,
    DashboardAccountSettingsAuditLogsRoute:
      DashboardAccountSettingsAuditLogsRoute,
    DashboardAccountSettingsDangerZoneRoute:
      DashboardAccountSettingsDangerZoneRoute,
    DashboardAccountSettingsMembersRoute: DashboardAccountSettingsMembersRoute,
    DashboardAccountSettingsSecurityRoute:
      DashboardAccountSettingsSecurityRoute,
    DashboardAccountSettingsIndexRoute: DashboardAccountSettingsIndexRoute,
    DashboardAccountSettingsTeamsIndexRoute:
      DashboardAccountSettingsTeamsIndexRoute,
    DashboardAccountSettingsTeamsTeamRoute:
      DashboardAccountSettingsTeamsTeamRouteWithChildren,
  }

const DashboardAccountSettingsRouteWithChildren =
  DashboardAccountSettingsRoute._addFileChildren(
    DashboardAccountSettingsRouteChildren,
  )

interface DashboardAccountGraphqlGraphBranchesBranchSettingsRouteChildren {
  DashboardAccountGraphqlGraphBranchesBranchSettingsIndexRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsIndexRoute
  DashboardAccountGraphqlGraphBranchesBranchSettingsBranchDangerZoneRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsBranchDangerZoneRoute
  DashboardAccountGraphqlGraphBranchesBranchSettingsBranchExplorerRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsBranchExplorerRoute
  DashboardAccountGraphqlGraphBranchesBranchSettingsBranchProposalsRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsBranchProposalsRoute
  DashboardAccountGraphqlGraphBranchesBranchSettingsGraphBranchesRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsGraphBranchesRoute
  DashboardAccountGraphqlGraphBranchesBranchSettingsGraphCustomChecksRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsGraphCustomChecksRoute
  DashboardAccountGraphqlGraphBranchesBranchSettingsGraphDangerZoneRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsGraphDangerZoneRoute
  DashboardAccountGraphqlGraphBranchesBranchSettingsGraphOperationChecksRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsGraphOperationChecksRoute
  DashboardAccountGraphqlGraphBranchesBranchSettingsGraphUsageRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsGraphUsageRoute
  DashboardAccountGraphqlGraphBranchesBranchSettingsGraphIndexRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsGraphIndexRoute
}

const DashboardAccountGraphqlGraphBranchesBranchSettingsRouteChildren: DashboardAccountGraphqlGraphBranchesBranchSettingsRouteChildren =
  {
    DashboardAccountGraphqlGraphBranchesBranchSettingsIndexRoute:
      DashboardAccountGraphqlGraphBranchesBranchSettingsIndexRoute,
    DashboardAccountGraphqlGraphBranchesBranchSettingsBranchDangerZoneRoute:
      DashboardAccountGraphqlGraphBranchesBranchSettingsBranchDangerZoneRoute,
    DashboardAccountGraphqlGraphBranchesBranchSettingsBranchExplorerRoute:
      DashboardAccountGraphqlGraphBranchesBranchSettingsBranchExplorerRoute,
    DashboardAccountGraphqlGraphBranchesBranchSettingsBranchProposalsRoute:
      DashboardAccountGraphqlGraphBranchesBranchSettingsBranchProposalsRoute,
    DashboardAccountGraphqlGraphBranchesBranchSettingsGraphBranchesRoute:
      DashboardAccountGraphqlGraphBranchesBranchSettingsGraphBranchesRoute,
    DashboardAccountGraphqlGraphBranchesBranchSettingsGraphCustomChecksRoute:
      DashboardAccountGraphqlGraphBranchesBranchSettingsGraphCustomChecksRoute,
    DashboardAccountGraphqlGraphBranchesBranchSettingsGraphDangerZoneRoute:
      DashboardAccountGraphqlGraphBranchesBranchSettingsGraphDangerZoneRoute,
    DashboardAccountGraphqlGraphBranchesBranchSettingsGraphOperationChecksRoute:
      DashboardAccountGraphqlGraphBranchesBranchSettingsGraphOperationChecksRoute,
    DashboardAccountGraphqlGraphBranchesBranchSettingsGraphUsageRoute:
      DashboardAccountGraphqlGraphBranchesBranchSettingsGraphUsageRoute,
    DashboardAccountGraphqlGraphBranchesBranchSettingsGraphIndexRoute:
      DashboardAccountGraphqlGraphBranchesBranchSettingsGraphIndexRoute,
  }

const DashboardAccountGraphqlGraphBranchesBranchSettingsRouteWithChildren =
  DashboardAccountGraphqlGraphBranchesBranchSettingsRoute._addFileChildren(
    DashboardAccountGraphqlGraphBranchesBranchSettingsRouteChildren,
  )

interface DashboardAccountGraphqlGraphBranchesBranchTracesRouteChildren {
  DashboardAccountGraphqlGraphBranchesBranchTracesIdRoute: typeof DashboardAccountGraphqlGraphBranchesBranchTracesIdRoute
}

const DashboardAccountGraphqlGraphBranchesBranchTracesRouteChildren: DashboardAccountGraphqlGraphBranchesBranchTracesRouteChildren =
  {
    DashboardAccountGraphqlGraphBranchesBranchTracesIdRoute:
      DashboardAccountGraphqlGraphBranchesBranchTracesIdRoute,
  }

const DashboardAccountGraphqlGraphBranchesBranchTracesRouteWithChildren =
  DashboardAccountGraphqlGraphBranchesBranchTracesRoute._addFileChildren(
    DashboardAccountGraphqlGraphBranchesBranchTracesRouteChildren,
  )

interface DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentRouteChildren {
  DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentBuildInputsRoute: typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentBuildInputsRoute
  DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentDiffRoute: typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentDiffRoute
  DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentSchemaRoute: typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentSchemaRoute
  DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentIndexRoute: typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentIndexRoute
}

const DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentRouteChildren: DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentRouteChildren =
  {
    DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentBuildInputsRoute:
      DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentBuildInputsRoute,
    DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentDiffRoute:
      DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentDiffRoute,
    DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentSchemaRoute:
      DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentSchemaRoute,
    DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentIndexRoute:
      DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentIndexRoute,
  }

const DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentRouteWithChildren =
  DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentRoute._addFileChildren(
    DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentRouteChildren,
  )

interface DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdRouteChildren {
  DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentRoute: typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentRouteWithChildren
}

const DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdRouteChildren: DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdRouteChildren =
  {
    DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentRoute:
      DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdDeploymentRouteWithChildren,
  }

const DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdRouteWithChildren =
  DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdRoute._addFileChildren(
    DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdRouteChildren,
  )

interface DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalRouteChildren {
  DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalActivityRoute: typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalActivityRoute
  DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalDiffRoute: typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalDiffRoute
  DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalEditorRoute: typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalEditorRoute
  DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalIndexRoute: typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalIndexRoute
}

const DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalRouteChildren: DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalRouteChildren =
  {
    DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalActivityRoute:
      DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalActivityRoute,
    DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalDiffRoute:
      DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalDiffRoute,
    DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalEditorRoute:
      DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalEditorRoute,
    DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalIndexRoute:
      DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalIndexRoute,
  }

const DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalRouteWithChildren =
  DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalRoute._addFileChildren(
    DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalRouteChildren,
  )

interface DashboardAccountGraphqlGraphBranchesBranchProposalsIdRouteChildren {
  DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalRoute: typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalRouteWithChildren
}

const DashboardAccountGraphqlGraphBranchesBranchProposalsIdRouteChildren: DashboardAccountGraphqlGraphBranchesBranchProposalsIdRouteChildren =
  {
    DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalRoute:
      DashboardAccountGraphqlGraphBranchesBranchProposalsIdProposalRouteWithChildren,
  }

const DashboardAccountGraphqlGraphBranchesBranchProposalsIdRouteWithChildren =
  DashboardAccountGraphqlGraphBranchesBranchProposalsIdRoute._addFileChildren(
    DashboardAccountGraphqlGraphBranchesBranchProposalsIdRouteChildren,
  )

interface DashboardAccountGraphqlGraphBranchesBranchRouteChildren {
  DashboardAccountGraphqlGraphBranchesBranchAnalyticsRoute: typeof DashboardAccountGraphqlGraphBranchesBranchAnalyticsRoute
  DashboardAccountGraphqlGraphBranchesBranchExplorerRoute: typeof DashboardAccountGraphqlGraphBranchesBranchExplorerRoute
  DashboardAccountGraphqlGraphBranchesBranchSchemaRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSchemaRoute
  DashboardAccountGraphqlGraphBranchesBranchSettingsRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSettingsRouteWithChildren
  DashboardAccountGraphqlGraphBranchesBranchSubgraphsRoute: typeof DashboardAccountGraphqlGraphBranchesBranchSubgraphsRoute
  DashboardAccountGraphqlGraphBranchesBranchTracesRoute: typeof DashboardAccountGraphqlGraphBranchesBranchTracesRouteWithChildren
  DashboardAccountGraphqlGraphBranchesBranchIndexRoute: typeof DashboardAccountGraphqlGraphBranchesBranchIndexRoute
  DashboardAccountGraphqlGraphBranchesBranchChangelogVersionRoute: typeof DashboardAccountGraphqlGraphBranchesBranchChangelogVersionRoute
  DashboardAccountGraphqlGraphBranchesBranchChecksIdRoute: typeof DashboardAccountGraphqlGraphBranchesBranchChecksIdRoute
  DashboardAccountGraphqlGraphBranchesBranchChecksIndexRoute: typeof DashboardAccountGraphqlGraphBranchesBranchChecksIndexRoute
  DashboardAccountGraphqlGraphBranchesBranchDeploymentsIndexRoute: typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIndexRoute
  DashboardAccountGraphqlGraphBranchesBranchProposalsIndexRoute: typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIndexRoute
  DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdRoute: typeof DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdRouteWithChildren
  DashboardAccountGraphqlGraphBranchesBranchProposalsIdRoute: typeof DashboardAccountGraphqlGraphBranchesBranchProposalsIdRouteWithChildren
}

const DashboardAccountGraphqlGraphBranchesBranchRouteChildren: DashboardAccountGraphqlGraphBranchesBranchRouteChildren =
  {
    DashboardAccountGraphqlGraphBranchesBranchAnalyticsRoute:
      DashboardAccountGraphqlGraphBranchesBranchAnalyticsRoute,
    DashboardAccountGraphqlGraphBranchesBranchExplorerRoute:
      DashboardAccountGraphqlGraphBranchesBranchExplorerRoute,
    DashboardAccountGraphqlGraphBranchesBranchSchemaRoute:
      DashboardAccountGraphqlGraphBranchesBranchSchemaRoute,
    DashboardAccountGraphqlGraphBranchesBranchSettingsRoute:
      DashboardAccountGraphqlGraphBranchesBranchSettingsRouteWithChildren,
    DashboardAccountGraphqlGraphBranchesBranchSubgraphsRoute:
      DashboardAccountGraphqlGraphBranchesBranchSubgraphsRoute,
    DashboardAccountGraphqlGraphBranchesBranchTracesRoute:
      DashboardAccountGraphqlGraphBranchesBranchTracesRouteWithChildren,
    DashboardAccountGraphqlGraphBranchesBranchIndexRoute:
      DashboardAccountGraphqlGraphBranchesBranchIndexRoute,
    DashboardAccountGraphqlGraphBranchesBranchChangelogVersionRoute:
      DashboardAccountGraphqlGraphBranchesBranchChangelogVersionRoute,
    DashboardAccountGraphqlGraphBranchesBranchChecksIdRoute:
      DashboardAccountGraphqlGraphBranchesBranchChecksIdRoute,
    DashboardAccountGraphqlGraphBranchesBranchChecksIndexRoute:
      DashboardAccountGraphqlGraphBranchesBranchChecksIndexRoute,
    DashboardAccountGraphqlGraphBranchesBranchDeploymentsIndexRoute:
      DashboardAccountGraphqlGraphBranchesBranchDeploymentsIndexRoute,
    DashboardAccountGraphqlGraphBranchesBranchProposalsIndexRoute:
      DashboardAccountGraphqlGraphBranchesBranchProposalsIndexRoute,
    DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdRoute:
      DashboardAccountGraphqlGraphBranchesBranchDeploymentsIdRouteWithChildren,
    DashboardAccountGraphqlGraphBranchesBranchProposalsIdRoute:
      DashboardAccountGraphqlGraphBranchesBranchProposalsIdRouteWithChildren,
  }

const DashboardAccountGraphqlGraphBranchesBranchRouteWithChildren =
  DashboardAccountGraphqlGraphBranchesBranchRoute._addFileChildren(
    DashboardAccountGraphqlGraphBranchesBranchRouteChildren,
  )

interface DashboardAccountRouteChildren {
  DashboardAccountSettingsRoute: typeof DashboardAccountSettingsRouteWithChildren
  DashboardAccountIndexRoute: typeof DashboardAccountIndexRoute
  DashboardAccountGraphqlIndexRoute: typeof DashboardAccountGraphqlIndexRoute
  DashboardAccountNexusIndexRoute: typeof DashboardAccountNexusIndexRoute
  DashboardAccountSupportIndexRoute: typeof DashboardAccountSupportIndexRoute
  DashboardAccountSupportThreadThreadIdRoute: typeof DashboardAccountSupportThreadThreadIdRoute
  DashboardAccountGraphqlGraphBranchesBranchRoute: typeof DashboardAccountGraphqlGraphBranchesBranchRouteWithChildren
}

const DashboardAccountRouteChildren: DashboardAccountRouteChildren = {
  DashboardAccountSettingsRoute: DashboardAccountSettingsRouteWithChildren,
  DashboardAccountIndexRoute: DashboardAccountIndexRoute,
  DashboardAccountGraphqlIndexRoute: DashboardAccountGraphqlIndexRoute,
  DashboardAccountNexusIndexRoute: DashboardAccountNexusIndexRoute,
  DashboardAccountSupportIndexRoute: DashboardAccountSupportIndexRoute,
  DashboardAccountSupportThreadThreadIdRoute:
    DashboardAccountSupportThreadThreadIdRoute,
  DashboardAccountGraphqlGraphBranchesBranchRoute:
    DashboardAccountGraphqlGraphBranchesBranchRouteWithChildren,
}

const DashboardAccountRouteWithChildren =
  DashboardAccountRoute._addFileChildren(DashboardAccountRouteChildren)

interface DashboardPersonalRouteChildren {
  DashboardPersonalSettingsAccessTokensRoute: typeof DashboardPersonalSettingsAccessTokensRoute
  DashboardPersonalSettingsDangerZoneRoute: typeof DashboardPersonalSettingsDangerZoneRoute
  DashboardPersonalSettingsIndexRoute: typeof DashboardPersonalSettingsIndexRoute
}

const DashboardPersonalRouteChildren: DashboardPersonalRouteChildren = {
  DashboardPersonalSettingsAccessTokensRoute:
    DashboardPersonalSettingsAccessTokensRoute,
  DashboardPersonalSettingsDangerZoneRoute:
    DashboardPersonalSettingsDangerZoneRoute,
  DashboardPersonalSettingsIndexRoute: DashboardPersonalSettingsIndexRoute,
}

const DashboardPersonalRouteWithChildren =
  DashboardPersonalRoute._addFileChildren(DashboardPersonalRouteChildren)

interface DashboardRouteChildren {
  DashboardAccountRoute: typeof DashboardAccountRouteWithChildren
  DashboardPersonalRoute: typeof DashboardPersonalRouteWithChildren
  DashboardMcpAuthCallbackRoute: typeof DashboardMcpAuthCallbackRoute
  DashboardNewOrganizationRoute: typeof DashboardNewOrganizationRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardInvitesIdRoute: typeof DashboardInvitesIdRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardAccountRoute: DashboardAccountRouteWithChildren,
  DashboardPersonalRoute: DashboardPersonalRouteWithChildren,
  DashboardMcpAuthCallbackRoute: DashboardMcpAuthCallbackRoute,
  DashboardNewOrganizationRoute: DashboardNewOrganizationRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardInvitesIdRoute: DashboardInvitesIdRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  DashboardRoute: DashboardRouteWithChildren,
  AdminRoute: AdminRoute,
  AuthTestRouteRoute: AuthTestRouteRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  AuthCliRoute: AuthCliRoute,
  AuthTestingRoute: AuthTestingRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
